//import React, { useState } from "react";

function About() {
  return (
    <div>
      <h2>About</h2>
      <p>
        Hello! I'm Taran. I made this website to showcase my web developement
        work.
      </p>

      <p>
        I am a fullstack web developer experienced in React, MongoDB, GraphQL,
        MongoDB, and more. I recently graduated from the University of Utah's
        fullstack coding bootcamp and focused on learning and practicing my
        skills as much as possible. In the interum,, I've been spending as much
        personal time as I can working on projects and honing my skills. Lately
        I've been focused on enhancing my 5 day weather forcast app,
        <a
          href="https://github.com/J3rkStore/toad-smoker"
          target="_blank"
          rel="noreferrer"
        >
          Weatheringo.
        </a>
      </p>
      <p>
        I have over 10 years IT experience and I'm working to make web
        developement my primary full-time ocupation by building interesting
        front ends supported by effective backends
      </p>
      <p>Go to the Portfolio section of this site to see my projects</p>
    </div>
  );
}

export default About;
